import React, { Component } from "react";
import PropTypes from "prop-types";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import Table from "@material-ui/core/Table";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import { deleteVehicle } from "../../graphql/mutations";
import { API, graphqlOperation, Auth } from "aws-amplify";

import { spinnerService } from "@chevtek/react-spinners";
// core components
import { Link } from "react-router-dom";
import tableStyle from "../../assets/jss/material-dashboard-react/components/tableStyle.jsx";
import { toast } from "react-toastify";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogTitle from "@material-ui/core/DialogTitle";
import awsConfigSettings from "../../aws-exports";
import { CognitoIdentityServiceProvider } from "aws-sdk";

class CustomTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showStatusDialog: false,
      crr: {
        username: "",
        active: false
      }
    };
  }

  handleEnableDisableBtn = (username, active) => {
    this.setState(
      {
        crr: {
          username,
          active: active === "Enabled" ? true : false
        }
      },
      () => {
        this.setState({ showStatusDialog: true });
      }
    );
  };

  componentDidMount() {
    this.props.onMount();
  }

  disableEnableUser = async (Username, flag) => {
    const self = this;
    spinnerService.show("mySpinner");
    try {
      let userPoolId = awsConfigSettings.aws_user_pools_id;
      let credentials = await Auth.currentCredentials();
      let client = await Promise.resolve(
        new CognitoIdentityServiceProvider({
          apiVersion: "2016-04-18",
          credentials: Auth.essentialCredentials(credentials),
          region: "us-east-2"
        })
      );
      let params = {
        UserPoolId: userPoolId /* required */,
        Username: Username /* required */
      };
      if (flag === "d") {
        await client.adminDisableUser(params, async function(err, data) {
          if (data !== null && err === null) {
            self.setState(
              {
                showStatusDialog: false
              },
              async () => {
                await self.props.onMount();
                toast.warn("User Disabled");
                spinnerService.hide("mySpinner");
              }
            );
          } else {
            toast.err("Disabling User Failed");
          }
        });
      } else if (flag === "e") {
        await client.adminEnableUser(params, async function(err, data) {
          if (data !== null && err === null) {
            self.setState(
              {
                showStatusDialog: false
              },
              async () => {
                await self.props.onMount();
                toast.success("User Enabled");

                spinnerService.hide("mySpinner");
              }
            );
          } else {
            toast.err("Enabling User Failed");
          }
        });
      }
      // self.props.onMount();
    } catch (err) {
      toast.err("An Error Occured, Try Again");
      spinnerService.hide("mySpinner");
    }
  };
  render() {
    const {
      classes,
      tableHead,
      tableData,
      tableHeaderColor,
      client,
      inspections
    } = this.props;
    const { crr } = this.state;

    return (
      <div>
        <Dialog
          open={this.state.showStatusDialog}
          onClose={() =>
            this.setState({
              showStatusDialog: false
            })
          }
          aria-labelledby="form-dialog-title"
        >
          <DialogTitle id="form-dialog-title">
            {crr.active ? "Disable User :" : "Enable User :"} {crr.username}
          </DialogTitle>
          <DialogActions>
            <Button
              onClick={() =>
                this.setState({
                  showStatusDialog: false
                })
              }
              color="primary"
            >
              No
            </Button>
            {crr.active ? (
              <Button
                onClick={() => this.disableEnableUser(crr.username, "d")}
                color="primary"
              >
                Yes
              </Button>
            ) : (
              <Button
                onClick={() => this.disableEnableUser(crr.username, "e")}
                color="primary"
              >
                Yes
              </Button>
            )}
          </DialogActions>
        </Dialog>
        <div className={classes.tableResponsive}>
          <Table className={classes.table}>
            <TableHead className={classes[tableHeaderColor + "TableHeader"]}>
              <TableRow>
                {tableHead !== undefined
                  ? tableHead.map((heading, key) => {
                      return (
                        <TableCell
                          className={
                            classes.tableCell + " " + classes.tableHeadCell
                          }
                          key={key}
                        >
                          {heading}
                        </TableCell>
                      );
                    }, this)
                  : null}
              </TableRow>
            </TableHead>
            <TableBody>
              {tableData.length !== 0
                ? tableData.map((dataProp, key) => {
                    return (
                      <TableRow key={key}>
                        <TableCell className={classes.tableCell}>
                          {dataProp.lastName}
                        </TableCell>
                        <TableCell className={classes.tableCell}>
                          {dataProp.id}
                        </TableCell>
                        <TableCell className={classes.tableCell}>
                          {dataProp.email}
                        </TableCell>

                        <TableCell className={classes.tableCell}>
                          {dataProp.phoneNo}
                        </TableCell>

                        <TableCell className={classes.tableCell}>
                          {dataProp.notes}
                        </TableCell>

                        <TableCell className={classes.tableCell}>
                          {dataProp.status}
                        </TableCell>
                        {dataProp.vehicle !== null ? (
                          <TableCell className={classes.tableCell}>
                            <Button
                              component={Link}
                              to={{
                                pathname: `/profile/details/${dataProp.empType}/${dataProp.id}`,
                                client: { client },
                                type: dataProp.empType
                              }}
                              color="primary"
                            >
                              {"Edit"}
                            </Button>
                          </TableCell>
                        ) : (
                          <TableCell className={classes.tableCell}>
                            {"Edit"}
                          </TableCell>
                        )}
                        <TableCell className={classes.tableCell}>
                          <Button
                            color="primary"
                            onClick={() =>
                              this.handleEnableDisableBtn(
                                dataProp.id,
                                dataProp.status
                              )
                            }
                          >
                            {dataProp.status === "Enabled"
                              ? "Disable User"
                              : "Enable User"}
                          </Button>
                        </TableCell>
                      </TableRow>
                    );
                  }, this)
                : null}
            </TableBody>
          </Table>
        </div>
      </div>
    );
  }
}

CustomTable.defaultProps = {
  tableHeaderColor: "gray"
};

CustomTable.propTypes = {
  classes: PropTypes.object.isRequired,
  tableHeaderColor: PropTypes.oneOf([
    "warning",
    "primary",
    "danger",
    "success",
    "info",
    "rose",
    "gray"
  ]),
  tableHead: PropTypes.arrayOf(PropTypes.string),
  tableData: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.string))
};

export default withStyles(tableStyle)(CustomTable);



// WEBPACK FOOTER //
// ./src/components/Table/VendorTeamTable.jsx